<template>
  <v-container fluid :class="classes">
    <template v-if="form">
      <div class="w-full" :class="formSize">
        <slot/>
      </div>
    </template>
    <template v-else>
      <slot/>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppPage',
  props: {
    form: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      ready: state => state.pagestate.ready
    }),
    classes () {
      const c = []

      if (!this.ready) {
        c.push('d-none')
      }
      if (this.form) {
        c.push('fill-height align-start justify-center')
      }

      return c.join(' ')
    },

    formSize () {
      if (!this.form) {
        return ''
      }
      if (this.form === true) {
        return 'max-w-md'
      }
      return `max-w-${this.form}`
    }
  }
}
</script>
